import { render, staticRenderFns } from "./SectionLive.vue?vue&type=template&id=2ec16c21&scoped=true"
import script from "./SectionLive.vue?vue&type=script&lang=js"
export * from "./SectionLive.vue?vue&type=script&lang=js"
import style0 from "./SectionLive.vue?vue&type=style&index=0&id=2ec16c21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec16c21",
  null
  
)

export default component.exports